// Layout.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { logout } from 'slice/userSlice';
import { useDispatch } from 'react-redux';
import { IoPersonCircleSharp } from 'react-icons/io5';
import { MdContacts } from 'react-icons/md';
import { GrGallery } from 'react-icons/gr';
// import { PiCurrencyDollarBold, } from "react-icons/pi";
import { FaCalendarAlt, FaEnvelope } from 'react-icons/fa';
// import { FaNewspaper } from 'react-icons/fa';
import { MdDashboard } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { FaVideo } from 'react-icons/fa';
import { FaUserTie } from 'react-icons/fa';

import logo from '../asserts/img/logo.png';
import { useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
  const [toggled, setToggle] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const dispatch = useDispatch();
  const nevigate = useNavigate();
  const location = useLocation();

  const currentUrl = location.pathname;
  const lastSegment = currentUrl.substring(currentUrl.lastIndexOf('/') + 1);
  const isStoryRoute = currentUrl.startsWith('/story');
  const isRepoterRoute = currentUrl.startsWith('/repoters');

  // Auto close mobile drawer and dropdown on route change
  useEffect(() => {
    setMobileOpen(false);
    setUserDropdownOpen(false);
  }, [location.pathname]);

  // Click outside to close user dropdown
  useEffect(() => {
    const handleClickOutside = (e) => {
      const container = document.getElementById('userDropdownContainer');
      if (container && !container.contains(e.target)) {
        setUserDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  const logoutHandler = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      sessionStorage.removeItem('token');
      dispatch(logout());
      nevigate('/signin');
    } catch (err) {
      console.log(err);
      nevigate('/signin');
    }
  };

  return (
    <>
      <div id="wrapper">
        {/* Mobile Backdrop */}
        <button
          type="button"
          aria-label="Close sidebar backdrop"
          className={`sidebar-backdrop ${mobileOpen ? "show" : ""}`}
          onClick={() => setMobileOpen(false)}
        />

        <ul
          className={`navbar-nav sidebar sidebar-danger ${toggled ? "toggled" : "accordion"} ${mobileOpen ? "mobile-show" : ""}`}
          id="accordionSidebar"
        >
          {/* Mobile Close Button */}
          <div className="d-flex justify-content-between align-items-center d-md-none px-3 py-2 border-bottom border-secondary mb-2">
            <span className="text-white font-weight-bold small text-uppercase">Menu</span>
            <button
              type="button"
              className="btn btn-sm btn-outline-light rounded-circle d-flex align-items-center justify-content-center"
              onClick={() => setMobileOpen(false)}
              style={{ width: "28px", height: "28px", padding: 0 }}
              aria-label="Close Menu"
            >
              <i className="fa fa-times"></i>
            </button>
          </div>
          <Link className="text-decoration-none justify-content-start" to="/dashboard">
            <div className="text-center">
              <img src={logo} alt="Bundeli Chugli" className="img-fluid adminlogo" />
            </div>
          </Link>
          {/* <hr className="sidebar-divider my-0" /> */}
          <li className="nav-item text-danger">
            <Link className="nav-link" to="/dashboard">
              <MdDashboard className="mr-1" />
              <span>Dashboard</span>
            </Link>
          </li>

          <li className={`nav-item text-danger ${lastSegment === 'ournews' ? 'active' : ''}`}>
            <Link
              className="nav-link text-danger collapsed"
              to="#"
              data-toggle="collapse"
              aria-expanded={openMenu === 'ournews'}
              onClick={() => toggleMenu('ournews')}
            >
              <FaCalendarAlt className="mr-1" />
              <span>Add Our News </span>
            </Link>
            <div id="ournews" className={`collapse ${openMenu === 'ournews' ? 'show' : ''}`} aria-labelledby="headingTwo">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/ournews/add">
                  Add News
                </Link>
                <Link className="collapse-item" to="/ournews">
                  Our News List
                </Link>
              </div>
            </div>
          </li>

          <li className={`nav-item text-danger ${isRepoterRoute ? 'active' : ''}`}>
            <Link
              className="nav-link text-danger collapsed"
              to="#"
              data-toggle="collapse"
              aria-expanded={openMenu === 'repoters'}
              onClick={() => toggleMenu('repoters')}
            >
              <FaUserTie className="mr-1" />
              <span>Repoters Profile</span>
            </Link>
            <div id="repoters" className={`collapse ${openMenu === 'repoters' ? 'show' : ''}`} aria-labelledby="headingRepoters">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/repoters/add">
                  Add Repoter
                </Link>
                <Link className="collapse-item" to="/repoters">
                  Repoters List
                </Link>
              </div>
            </div>
          </li>

          <li className={`nav-item text-danger ${lastSegment === 'media' ? 'active' : ''}`}>
            <Link
              className="nav-link text-danger collapsed"
              href="#"
              data-toggle="collapse"
              aria-expanded={openMenu === 'media'}
              onClick={() => toggleMenu('media')}
            >
              <FaVideo className="mr-2" /> {/* ✅ ICON ADDED */}
              <span>Video</span>
            </Link>

            <div id="media" className={`collapse ${openMenu === 'media' ? 'show' : ''}`} aria-labelledby="headingMedia">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/media/add">
                  Add Video
                </Link>

                <Link className="collapse-item" to="/media">
                  Video List
                </Link>
              </div>
            </div>
          </li>

          {/* Our GAllery */}
          <li className={`nav-item text-danger ${lastSegment === 'gallery' ? 'active' : ''}`}>
            <Link
              className="nav-link text-danger collapsed"
              to="#"
              data-toggle="collapse"
              aria-expanded={openMenu === 'gallery'}
              onClick={() => toggleMenu('gallery')}
            >
              <GrGallery className="mr-1" />
              <span>Our Gallery</span>
            </Link>
            <div id="ourteam" className={`collapse ${openMenu === 'gallery' ? 'show' : ''}`} aria-labelledby="headingTwo">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/gallery/add">
                  Add Our Gallery
                </Link>
                <Link className="collapse-item" to="/gallery">
                  Our Gallery List
                </Link>
              </div>
            </div>
          </li>

          {/* Story */}
          <li className={`nav-item text-danger ${isStoryRoute ? 'active' : ''}`}>
            <Link
              className="nav-link text-danger collapsed"
              to="#"
              data-toggle="collapse"
              aria-expanded={openMenu === 'story'}
              onClick={() => toggleMenu('story')}
            >
              <GrGallery className="mr-1" />
              <span>Story</span>
            </Link>
            <div id="story" className={`collapse ${openMenu === 'story' ? 'show' : ''}`} aria-labelledby="headingStory">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/story/add">
                  Add Story
                </Link>
                <Link className="collapse-item" to="/story">
                  Story List
                </Link>
              </div>
            </div>
          </li>

          {/* Contact Us */}
          {/* <li className={`nav-item text-danger ${lastSegment === 'contactus' ? 'active' : ''}`}>
                        <Link
                            className="nav-link collapsed"
                            to="#"
                            data-toggle="collapse"
                            aria-expanded={openMenu === 'contactus'}
                            onClick={() => toggleMenu('contactus')}
                        >
                            <MdContacts className='mr-1' />
                            <span>Enquiry</span>
                        </Link>
                        <div
                            id="contactus"
                            className={`collapse ${openMenu === 'contactus' ? 'show' : ''}`}
                            aria-labelledby="headingTwo"
                        >
                            <div className="bg-white py-2 collapse-inner rounded">
                                <Link className="collapse-item text-danger" to="/contactus">Enquiry List</Link>
                            </div>
                        </div>
                    </li> */}

          <li className={`nav-item text-danger ${lastSegment === 'contactus' ? 'active' : ''}`}>
            <Link
              className="nav-link text-danger collapsed"
              to="#"
              aria-expanded={openMenu === 'contactus'}
              onClick={() => toggleMenu('contactus')}
            >
              <MdContacts className="mr-1" />
              <span>Enquiry</span>
            </Link>

            <div id="contactus" className={`collapse ${openMenu === 'contactus' ? 'show' : ''}`}>
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item text-danger" to="/contactus">
                  Enquiry List
                </Link>
              </div>
            </div>
          </li>

          {/* teammessage  */}
          <li className={`nav-item text-danger ${lastSegment === 'teammessage' ? 'active' : ''}`}>
            <Link
              className="nav-link text-danger collapsed"
              to="#"
              data-toggle="collapse"
              aria-expanded={openMenu === 'teammessage'}
              onClick={() => toggleMenu('teammessage')}
            >
              <FaEnvelope className="mr-1" /> {/* TeamMessage icon */}
              <span>advertising</span>
            </Link>

            <div id="teammessage" className={`collapse ${openMenu === 'teammessage' ? 'show' : ''}`} aria-labelledby="headingTeamMessage">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/team-message/add">
                  Add advertising
                </Link>
                <Link className="collapse-item" to="/team-message/list">
                  advertising List
                </Link>
              </div>
            </div>
          </li>

          {/* schoolnotification */}
          {/* <li className={`nav-item text-danger ${lastSegment === 'schoolnotification' ? 'active' : ''}`}>
                        <Link
                            className="nav-link text-danger collapsed"
                            href="#"
                            data-toggle="collapse"
                            aria-expanded={openMenu === 'schoolnotification'}
                            onClick={() => toggleMenu('schoolnotification')}
                        >
                            <FaBell className='mr-1' /> 
                            <span>School Notifications</span>
                        </Link>
                        <div
                            id="schoolnotification"
                            className={`collapse ${openMenu === 'schoolnotification' ? 'show' : ''}`}
                            aria-labelledby="headingSchoolNotifications"
                        >
                            <div className="bg-white py-2 collapse-inner rounded">
                                <Link className="collapse-item" to="/schoolnotifications/add">Add Notification</Link>
                                <Link className="collapse-item" to="/schoolnotifications/list">Notifications List</Link>
                            </div>
                        </div>
                    </li> */}

          <div className="text-center text-danger d-none d-md-inline mt-5">
            <button className="rounded-circle border-0 text-danger" id="sidebarToggle" onClick={() => setToggle(!toggled)}></button>
          </div>
        </ul>

        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
              <button id="sidebarToggleTop" onClick={() => setMobileOpen(!mobileOpen)} className="btn btn-link d-md-none rounded-circle mr-3" aria-label="Toggle Menu">
                <i className="fa fa-bars fa-lg" style={{ color: "#003366" }}></i>
              </button>
              <ul className="navbar-nav ml-auto">
                {/* <div className="topbar-divider d-none d-sm-block"></div> */}
                <li
                  className={`nav-item dropdown no-arrow position-relative ${userDropdownOpen ? 'show' : ''}`}
                  id="userDropdownContainer"
                >
                  <button
                    type="button"
                    className="nav-link dropdown-toggle btn btn-link d-flex align-items-center text-decoration-none border-0"
                    id="userDropdown"
                    onClick={(e) => {
                      e.stopPropagation();
                      setUserDropdownOpen((prev) => !prev);
                    }}
                    style={{ background: 'transparent', cursor: 'pointer', outline: 'none' }}
                    aria-haspopup="true"
                    aria-expanded={userDropdownOpen}
                  >
                    <span className="mr-2 d-none d-lg-inline admintext small font-weight-bold">Admin</span>
                    <IoPersonCircleSharp size={26} style={{ color: '#003366' }} />
                    <i
                      className="fa-solid fa-chevron-down ml-1 text-muted"
                      style={{
                        fontSize: '10px',
                        transform: userDropdownOpen ? 'rotate(180deg)' : 'none',
                        transition: 'transform 0.2s'
                      }}
                    ></i>
                  </button>

                  <div
                    className={`dropdown-menu dropdown-menu-right shadow animated--grow-in ${userDropdownOpen ? 'show' : ''}`}
                    aria-labelledby="userDropdown"
                    style={{
                      display: userDropdownOpen ? 'block' : 'none',
                      position: 'absolute',
                      right: 0,
                      top: '100%',
                      zIndex: 1050,
                      minWidth: '170px',
                      borderRadius: '8px',
                      border: '1px solid #e9ecef',
                      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                      padding: '0.5rem 0'
                    }}
                  >
                    <div className="px-3 py-2 border-bottom mb-1">
                      <div className="font-weight-bold text-dark" style={{ fontSize: '13px' }}>
                        Admin
                      </div>
                      <small className="text-success font-weight-bold" style={{ fontSize: '11px' }}>
                        <i className="fa-solid fa-circle mr-1" style={{ fontSize: '8px' }}></i> Online
                      </small>
                    </div>
                    <button
                      type="button"
                      className="dropdown-item d-flex align-items-center text-danger font-weight-bold py-2"
                      style={{ cursor: 'pointer', fontSize: '13px' }}
                      onClick={logoutHandler}
                    >
                      <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-danger"></i>
                      Logout
                    </button>
                  </div>
                </li>
              </ul>
            </nav>
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
